var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 0.333336C5.55617 0.333336 0.333008 5.5565 0.333008 12C0.333008 18.4435 5.55617 23.6667 11.9997 23.6667C18.4432 23.6667 23.6663 18.4435 23.6663 12C23.6663 5.5565 18.4432 0.333336 11.9997 0.333336ZM12.8747 17.25C12.8747 17.733 12.4827 18.125 11.9997 18.125C11.5167 18.125 11.1247 17.733 11.1247 17.25V11.9171C11.1247 11.4341 11.5167 11.0421 11.9997 11.0421C12.4827 11.0421 12.8747 11.4341 12.8747 11.9171V17.25ZM12.023 9.08334C11.379 9.08334 10.8504 8.56067 10.8504 7.91667C10.8504 7.27267 11.3674 6.75 12.0114 6.75H12.023C12.6682 6.75 13.1897 7.27267 13.1897 7.91667C13.1897 8.56067 12.667 9.08334 12.023 9.08334Z",
    fill: "#A8ADCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.5a261b19ec72871b4161d732ba2cc577.svg";
export { ForwardRef as ReactComponent };